
























































import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import DesktopNavTemplate from '@components/header/navigation/desktop/desktop-nav-template.vue';
import { HeaderStyle } from 'types/header';
import { investmentEntity } from '@store/modules/investment-entity';
import { InvestmentEntity } from 'types/investment-entity';
import { Link } from 'types/layout';
import NavDropdownHeader from '../nav-dropdown-header.vue';
import NavigationLinkDesktop from './navigation-link-desktop.vue';
import NavInvestmentEntityList from '../nav-investment-entity-list.vue';
import NotificationDropdown from '@components/header/navigation/notification-dropdown.vue';
import { settingsLinks } from '../links';
import { user } from '@store/modules/user';

@Component({
	components: {
		DesktopNavTemplate,
		NavDropdownHeader,
		NavigationLinkDesktop,
		NavInvestmentEntityList,
		NotificationDropdown
	}
})
export default class DesktopNavAuth extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	settingsLinks: Array<Link> = settingsLinks;

	get displayName(): string {
		if (this.nav.multipleInvestmentEntities && investmentEntity.investmentEntityName) {
			return investmentEntity.investmentEntityName;
		} else if (!this.nav.multipleInvestmentEntities && user.user && user.user.firstName) {
			return user.user.firstName;
		} else {
			return 'Your Account';
		}
	}

	get displayAccountType(): string {
		if (this.investmentEntityObject.isIraEntity) {
			if (this.investmentEntityObject.iraEntityMetadata.iraTypeLabel) {
				return this.investmentEntityObject.iraEntityMetadata.iraTypeLabel + ' IRA';
			}
			return 'Undesignated IRA';
		} else if (this.nav.multipleInvestmentEntities) {
			return this.investmentEntityObject.entityTypeLabel ?? '';
		}
		return '';
	}

	get investmentEntityObject(): InvestmentEntity {
		return investmentEntity.investmentEntityObject;
	}

	get iraTypeLabel(): string {
		return this.investmentEntityObject.iraEntityMetadata.iraTypeLabel ?? '';
	}

	get nav(): AuthenticatedNav {
		return new AuthenticatedNav(user.user, this.investmentEntityObject);
	}
}
